import { render, staticRenderFns } from "./StudentFilterComponent.vue?vue&type=template&id=543a0494&scoped=true&"
import script from "./StudentFilterComponent.vue?vue&type=script&lang=js&"
export * from "./StudentFilterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543a0494",
  null
  
)

export default component.exports